import AsyncStorage from '@react-native-async-storage/async-storage';
import { clearQueue } from './requestQueue';

const STORAGE_KEY = 'offlineModeEntitled';

let entitled = false;
let hydrated = false;

/**
 * Offline mode (queue, disk cache, offline login) is a paid entitlement.
 * Flag is synced from subscription state while online and persisted for offline checks.
 */
export const isOfflineModeEntitled = (): boolean => entitled;

export const hydrateOfflineModeEntitlement = async (): Promise<boolean> => {
	try {
		const value = await AsyncStorage.getItem(STORAGE_KEY);
		entitled = value === '1';
	} catch (error) {
		console.warn('Failed to hydrate offline mode entitlement:', error);
		entitled = false;
	}
	hydrated = true;
	return entitled;
};

export const isOfflineModeEntitlementHydrated = (): boolean => hydrated;

export const setOfflineModeEntitled = async (next: boolean): Promise<void> => {
	const previous = entitled;
	entitled = Boolean(next);
	try {
		if (entitled) {
			await AsyncStorage.setItem(STORAGE_KEY, '1');
		} else {
			await AsyncStorage.removeItem(STORAGE_KEY);
			if (previous) {
				await clearQueue();
			}
		}
	} catch (error) {
		console.warn('Failed to persist offline mode entitlement:', error);
	}
};

export const clearOfflineModeEntitlement = async (): Promise<void> => {
	await setOfflineModeEntitled(false);
};
